import React from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/**
 * JargonTip — inline info icon next to an industry term.
 *   <p>Recovery <JargonTip label="CEI proxy">Collection Effectiveness Index — % of due that's actually collected</JargonTip></p>
 */
export const JargonTip = ({ children, className, side = 'top' }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Definition"
          className={cn(
            'inline-flex items-center justify-center align-middle ml-1 h-3.5 w-3.5 rounded-full',
            'text-muted-foreground hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-primary',
            className
          )}
        >
          <Info className="h-3 w-3" />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs text-xs leading-relaxed">
        {children}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default JargonTip;
